import { Link } from "react-router-dom";

import { motion } from "framer-motion";
import PageMeta from "../../shared/PageMeta";
import GridShape from "../../shared/GridShape";
import { useAuth } from "../../context/AuthContext";

export default function Unauthorized() {
  const { role, activeDepartment } = useAuth();

  return (
    <>
      <PageMeta
        title="SORIGIN | Unauthorized"
        description="SORIGIN - You don't have access to this page"
      />
      <div className="relative flex flex-col h-[100dvh] overflow-hidden bg-white dark:bg-gray-900 z-0 px-4">
        <GridShape />

        <div className="flex flex-col items-center justify-center flex-1 max-w-[440px] w-full mx-auto text-center">
          <motion.h4
            className="text-[22px] font-semibold text-[#334E41] dark:text-white mb-2"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
          >
            You don't have access to this page
          </motion.h4>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
          >
            <img
              src="/images/error/404.svg"
              alt="Unauthorized"
              className="w-[400px] max-w-full mx-auto dark:hidden"
            />
          </motion.div>

          <p className="mt-3 text-sm text-gray-600 dark:text-gray-400">
            Your role doesn't have permission for this resource. Contact your administrator if you think this is a mistake.
          </p>

          <div className="mt-4 text-xs font-mono text-gray-500 dark:text-gray-400 bg-gray-50 dark:bg-gray-800 rounded-md px-3 py-2 border border-gray-200 dark:border-gray-700">
            <div>role: {role ?? "—"}</div>
            <div>department: {activeDepartment ?? "—"}</div>
          </div>

          <motion.div
            className="mt-4"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.97 }}
          >
            <Link
              to="/"
              className="inline-block px-6 py-2 rounded-md bg-[#339274] text-white font-medium text-sm shadow hover:bg-[#2e7b64] transition"
            >
              ←  Back to home
            </Link>
          </motion.div>
        </div>

        <p className="text-center text-sm text-gray-500 dark:text-gray-400 pb-2">
          &copy; {new Date().getFullYear()} — SORIGIN
        </p>
      </div>
    </>
  );
}
